// extracted by mini-css-extract-plugin
export var closeButton = "_71-0";